var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1002,
    height: 1864,
    viewBox: "0 0 1002 1864",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5002 2C-16.4998 67.8333 -13.4999 191.7 64.5001 230.5C142.5 269.3 168 284.5 191.5 297.5C241.889 325.375 341.4 362 365 358C394.5 353 433 345.5 467 304C501 262.5 569.5 143 640 172.5C696.4 196.1 744.5 257 761.5 284.5C809.333 406.333 887.5 663.6 817.5 718C730 786 608 800.5 554.5 822.5C501 844.5 180 917 175 1000C170 1083 191.5 1132 216 1161C240.5 1190 345.5 1321.5 467 1353C588.5 1384.5 749 1413.5 734.5 1477C720 1540.5 1043.5 1602 995 1716C956.2 1807.2 978.833 1851.33 995 1862",
    stroke: "#E6DDD2",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashline);
export default __webpack_public_path__ + "static/media/dashline.fb1ddb48f71dcdcbc34d6375e032381d.svg";
export { ForwardRef as ReactComponent };